module.exports = __webpack_public_path__ + "img/02.900e6e8c.png";